import { useNavContainer } from '@procureai/ui-mui';

import { useRuntime } from '../RuntimeProvider';
import { useAppRemoteState } from '~/hooks/useAppRemoteState/useAppRemoteState';
import { UseAppRemoteStateResult } from '~/hooks/useAppRemoteState/useAppRemoteState.types';
import { useIntercomWithUser } from '~/hooks/useIntercomWithUser/useIntercomWithUser';

export interface UseAppContentResult {
  showNavbar: boolean;
  loading: boolean;
  pinned: boolean;
  hover: boolean;
  onContainerMouseOver: () => void;
  onContainerMouseLeave: () => void;
  setAppState: UseAppRemoteStateResult[1];
}

export const useAppContent = (): UseAppContentResult => {
  useIntercomWithUser();
  const { runtime } = useRuntime();
  const isAppRunningAsTeamsApp = runtime?.type === 'MSTeams';
  const isAppRunningAsBrowserExtension = runtime?.type === 'browserExtension';

  const [appState, setAppState, { loading }] = useAppRemoteState();
  const { hover, onContainerMouseOver, onContainerMouseLeave } = useNavContainer({
    pinned: appState.navDrawerPinned,
  });

  const showNavbar = isAppRunningAsTeamsApp || isAppRunningAsBrowserExtension ? false : true;

  const pinned = isAppRunningAsTeamsApp || isAppRunningAsBrowserExtension ? false : appState.navDrawerPinned;

  return {
    showNavbar,
    loading,
    pinned,
    hover,
    setAppState,
    onContainerMouseOver,
    onContainerMouseLeave,
  };
};
